/*
  Ivy Pillow — chevrons op de productfoto (desktop): bladeren door de media
  door de vorige/volgende thumbnail te activeren. Dawn's media-gallery.js
  doet daarna het echte werk (setActiveMedia + aria-current).
*/
(() => {
  function init(scope) {
    const bereik = scope && scope.querySelectorAll ? scope : document;
    bereik.querySelectorAll('[data-ivy-galerij-pijlen]').forEach((pijlen) => {
      if (pijlen.dataset.ivyInit === 'true') return;
      pijlen.dataset.ivyInit = 'true';

      const galerij = pijlen.closest('media-gallery');
      if (!galerij) return;

      // Slide-wissel: de actieve index als CSS-variabele op de medialijst,
      // zodat de track smooth kan verschuiven (CSS doet de animatie)
      const lijst = galerij.querySelector('.product__media-list');
      if (lijst) {
        const zetIndex = () => {
          const items = Array.from(lijst.querySelectorAll('.product__media-item'));
          const idx = items.findIndex((li) => li.classList.contains('is-active'));
          lijst.style.setProperty('--ivy-galerij-index', Math.max(0, idx));
        };
        zetIndex();
        new MutationObserver(zetIndex).observe(lijst, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class'],
        });
      }

      pijlen.querySelectorAll('.ivy-galerij-pijl').forEach((knop) => {
        knop.addEventListener('click', () => {
          const richting = parseInt(knop.dataset.richting, 10) || 1;
          const thumbs = Array.from(galerij.querySelectorAll('.thumbnail-list__item .thumbnail'));
          if (thumbs.length < 2) return;
          let huidig = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
          if (huidig < 0) huidig = 0;
          const volgende = (huidig + richting + thumbs.length) % thumbs.length;
          thumbs[volgende].click();
          thumbs[volgende].closest('li')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  }
})();
